import React, { useState, useContext, useRef, useEffect } from "react";
import { User, Menu, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext/AuthContext";
import "./Navbar.css";

const Navbar = () => {
  const { user, isSignedIn, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  console.log("Navbar - user:", user, "isSignedIn:", isSignedIn);
  console.log("Navbar - username specifically:", user?.username);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleSignOut = () => {
    logout();
    setIsDropdownOpen(false);
    navigate("/signin");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar-container" aria-label="Main navigation">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <img
            src="/ll_logo.png"
            alt="LingoLab Logo"
            className="navbar-logo"
            onError={(e) => {
              e.target.src = "/fallback-logo.png"; // Fallback image
              e.target.alt = "LingoLab Fallback Logo";
            }}
          />
          <span className="navbar-title">LingoLab</span>
        </Link>
        <div className="navbar-links">
          <Link to="/initial-translation-order" className="navbar-link">
            Translate Video
          </Link>
          <Link to="/news" className="navbar-link">
            News
          </Link>
          <Link to="/demos" className="navbar-link">
            Demos
          </Link>
          <Link to="/about" className="navbar-link">
            About
          </Link>
          <Link to="/contact" className="navbar-link">
            Contact
          </Link>
          <Link to="/my-orders" className="navbar-link">
            My Orders
          </Link>
          {isSignedIn ? (
            <div className="navbar-dropdown" ref={dropdownRef}>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onTouchStart={() => {}}
                className="navbar-dropdown-toggle"
                aria-expanded={isDropdownOpen}
                aria-haspopup="true"
              >
                <User size={20} className="navbar-icon" />
                <span>{user?.username || "Account"}</span>
              </button>
              {isDropdownOpen && (
                <div className="navbar-dropdown-menu">
                  <Link
                    to="/settings"
                    className="navbar-dropdown-item"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    Settings
                  </Link>
                  <button
                    onClick={handleSignOut}
                    onTouchStart={() => {}}
                    className="navbar-dropdown-item navbar-signout"
                    aria-label="Sign out"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/signin" className="navbar-link navbar-signin">
              <User size={20} className="navbar-icon" />
              <span>Sign In</span>
            </Link>
          )}
        </div>
        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          onTouchStart={() => {}}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {isMenuOpen && (
        <div className="navbar-mobile-menu" id="mobile-menu">
          <Link
            to="/initial-translation-order"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            Translate Video
          </Link>
          <Link
            to="/news"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            News
          </Link>
          <Link
            to="/demos"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            Demos
          </Link>
          <Link
            to="/about"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/contact"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
          <Link
            to="/my-orders"
            className="navbar-mobile-link"
            onClick={() => setIsMenuOpen(false)}
          >
            My Orders
          </Link>
          {isSignedIn ? (
            <div className="navbar-dropdown" ref={dropdownRef}>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onTouchStart={() => {}}
                className="navbar-mobile-dropdown-toggle"
                aria-expanded={isDropdownOpen}
                aria-haspopup="true"
              >
                <User size={20} className="navbar-icon" />
                <span>{user?.username || "Account"}</span>
              </button>
              {isDropdownOpen && (
                <div className="navbar-mobile-dropdown-menu">
                  <button
                    onClick={handleSignOut}
                    onTouchStart={() => {}}
                    className="navbar-mobile-dropdown-item navbar-signout"
                    aria-label="Sign out"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link
              to="/signin"
              className="navbar-mobile-link navbar-signin"
              onClick={() => setIsMenuOpen(false)}
            >
              <User size={20} className="navbar-icon" />
              <span>Sign In</span>
            </Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
